




























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { DateTextLayer } from "@/model/document2/page/surface/design/layer/dateTextLayer";
import { MathHelper } from '@/helper/mathHelper';

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class FontStyleController extends Vue 
{
    @Prop() layer! : DateTextLayer;

    private static readonly BOLD_ON = "太字";
    private static readonly BOLD_OFF = "細字";
    private static readonly ITALIC_ON = "斜体";
    private static readonly ITALIC_OFF = "正体";
    private static readonly UNDERLINE_ON = "下線あり";
    private static readonly UNDERLINE_OFF = "下線なし";

    private static readonly MAX_LETTER_WIDTH = 250;
    private get maxLetterWidth() { return FontStyleController.MAX_LETTER_WIDTH; }

    private getTextInfo(name : string)
    {
        return this.layer.textInfo[name];
    }

    private get letterWidth()
    {
        var value = this.getTextInfo("letterWidth");
        return value != null ? Math.min(value, FontStyleController.MAX_LETTER_WIDTH) : 100;
    }

    private set letterWidth(letterWidth)
    {
        this.changeTextInfo("letterWidth", Number(letterWidth), false, false);
    }

    private get letterWidthText()
    {
        return this.letterWidth.toFixed() + "%";
    }

    private onLetterWidthChanged()
    {
        this.changeTextInfo("letterWidth", this.letterWidth, true, false);
    }

    private get boldText()
    {
        var bold = this.getTextInfo("bold");
        return bold != null && bold ? FontStyleController.BOLD_ON : FontStyleController.BOLD_OFF;
    }

    private changeBold()
    {
        var bold = this.getTextInfo("bold");
        var newBold = !(bold != null && bold);
        this.changeTextInfo("bold", newBold, true, true);
    }

    private get italicText()
    {
        var italic = this.getTextInfo("italic");
        return italic != null && italic ? FontStyleController.ITALIC_ON : FontStyleController.ITALIC_OFF;
    }

    private changeItalic()
    {
        var italic = this.getTextInfo("italic");
        var newItalic = !(italic != null && italic);
        this.changeTextInfo("italic", newItalic, true, true);
    }

    private get underlineText()
    {
        var underline = this.getTextInfo("underline");
        return underline != null && underline ? FontStyleController.UNDERLINE_ON : FontStyleController.UNDERLINE_OFF;
    }

    private changeUnderline()
    {
        var underline = this.getTextInfo("underline");
        var newUnderline = !(underline != null && underline);
        this.changeTextInfo("underline", newUnderline, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }

    private changeTextInfo(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeTextInfo", propertyName, value, isFinish, isOnce);
    }
}
